<template>
	<div>
		<div class="language_panel">
			<div class="m_container" style="display: grid; grid-template-columns: 1fr 1fr; height: 100%;">
				<div class="language_header">
					<img src="../assets/images/figma/Telekom.svg"/>
					<div class="link-tmo" v-on:click="redirectToTmo()" v-html="$t('backToTMO')"></div>
				</div>
			</div>
		</div>
		<div class="header_section">
			<div class="m_container">
				<div class="jazyk_zmena_wrapper" style="cursor: pointer;" v-on:click="changeLang()">
					<div v-if="jazyk_aktivni == 'cs'" class="jazyk_prepinac_wrapper" style="place-self: start right;">
						<img class="jazyk_ikonka" src="../assets/images/figma/eng_img.png"/>
						<div class="jazyk_text">{{ $t('englishLang') }}</div>
					</div>
					<div v-if="jazyk_aktivni == 'en'" class="jazyk_prepinac_wrapper" style="place-self: start right;">
						<img class="jazyk_ikonka" src="../assets/images/figma/cz_img.png"/>
						<div class="jazyk_text">{{ $t('czechLang') }}</div>
					</div>
				</div>
				<div class="puzzle_piece" style="place-self: start left;">
					<div class="puzzle_piece_text" v-html="$t('improveTariffLabel')">

					</div>
				</div>
			</div>
		</div>
		<div class="m_container message_grid first_message" style="margin-top: 60px; margin-bottom: 64px;">
			<img class="message_icon" src="../assets/images/figma/new/Support.svg"/>
			<div class="message_text_part">
				<div class="message_nadpis">{{ $t('supportTitle') }}</div>
				<div class="message_text">
					{{ $t('supportDesc') }}
				</div>
				<div v-on:click="scrollToId('loginTitle')" class="btn_app btn_magenta" style="padding: 0px 19px 0px 19px; cursor: pointer;">{{ $t('supportCta') }}</div>
			</div>
		</div>

		<div class="m_container nadpis_main_sekce">{{ $t('cardsTitle') }}</div>

		<div class="m_container galerie_wrapper" style="padding: 0; padding-bottom: 80px;">
			<div class="galerie_item pet_g_item" @click="toggle_card('Pet_G')">
				<Transition name="fade" mode="out-in">
					<component :is="pet_g_show"></component>
				</Transition>
			</div>
			<div class="galerie_item vice_dat_item" @click="toggle_card('Vice_dat')">
				<Transition name="fade" mode="out-in">
					<component :is="vice_dat_show"></component>
				</Transition>
			</div>
			<div class="galerie_item nadupane_telefony_item" @click="toggle_card('Nadupane_telefony')">
				<Transition name="fade" mode="out-in">
					<component :is="nadupane_telefony_show"></component>
				</Transition>
			</div>
			<div class="galerie_item porad_online_item" @click="toggle_card('Porad_online')">
				<Transition name="fade" mode="out-in">
					<component :is="porad_online_show"></component>
				</Transition>
			</div>
			<div class="galerie_item tv_mini_item" @click="toggle_card('Tv_mini')">
				<Transition name="fade" mode="out-in">
					<component :is="tv_mini_show"></component>
				</Transition>
			</div>
			<div class="galerie_item magenta_item" @click="toggle_card('Magenta')">
				<Transition name="fade" mode="out-in">
					<component :is="magenta_show"></component>
				</Transition>
			</div>
		</div>

		<div class="login_container" id="loginTitle">
			<div class="m_container login_header" style="padding-bottom: 19px">
				{{ $t('migrationTitle') }}
			</div>

			<div v-if="isLoginAvailable"
					 class="text-center c_text">
				<div class="vertical-align padding-login-ok">
					<img src="../assets/images/icons/login_ok.svg" width="24" height="24" alt="login_ok">
					<span style="padding-left: 5px;">{{ $t('migrationLogin') }}</span>

				</div>
        <div class="action_wrapper_logout">
          <span><logout /></span>
        </div>

			</div>

			<div v-if="isLoginAvailable && isMigrationDataLoaded && !dataError && isRelevantUseCase" class="m_container login_cards_wrapper" style="padding: 0;">
				<div class="login_card_wrapper login_first_card">
					<div class="login_card_icon_wrapper">
						<img src="../assets/images/figma/Data.svg"/>
					</div>
					<div class="login_card_nadpis">{{ $t('migrationCardTitle') }}</div>
					<div class="login_card_text">
						{{ $t('migrationCardDesc') }}
					</div>
				</div>
				<div class="login_card_wrapper login_second_card">
					<div class="login_card_icon_wrapper">
						<img src="../assets/images/figma/Ratings.svg"/>
					</div>
					<div class="login_card_nadpis">{{ $t('migrationCardTitle2') }}</div>
					<div class="login_card_text">
						{{ $t('migrationCardDesc2') }}
					</div>
				</div>
				<div class="login_card_wrapper login_last_card">
					<div class="login_card_icon_wrapper">
						<img src="../assets/images/figma/new/Support.svg"/>
					</div>
					<div class="login_card_nadpis">{{ $t('migrationCardTitle3') }}</div>
					<div class="login_card_text">
						{{ $t('migrationCardDesc3') }}
					</div>
				</div>
			</div>

			<div v-if="!isLoginAvailable" class="m_container message_grid" style="margin-bottom: 40px;">
				<img class="message_icon" src="../assets/images/figma/new/user_icon.svg"/>
				<div class="message_text_part">
					<div class="message_text_special" v-html="$t('loginInfoTitle')"></div>
				</div>
			</div>

			<LoginComponent/>
			<ZmenaTarifComponent v-if="isLoginAvailable" ref="tariffComponent"/>

		</div>

		<div v-if="isLoginAvailable && isMigrationDataLoaded && !dataError && isRelevantUseCase" style="background-color: white; width: 100%; padding-bottom: 70px; padding-top: 80px;">
			<div class="m_container magenta_area">
				<div class="t_container text" style="padding-top: 444px;">
					{{ $t('magentaHeartsDesc') }}
				</div>
			</div>
		</div>

		<div class="faq_container">
			<div class="t_container nadpis">{{ $t('faqTitle') }}</div>
			<div v-if="!isLoginAvailable" class="t_container faq_wrapper">
				<div id="faq_1" class="faq_item" @click="toggleFAQ('faq_1')">
					<div class="item_nadpis" v-html="$t('faqQuestion')"></div>
					<div class="item_znamenko"></div>
					<div class="item_inside" v-html="$t('faqAnswer')">
					</div>
				</div>
				<div id="faq_2" class="faq_item" @click="toggleFAQ('faq_2')">
					<div class="item_nadpis" v-html="$t('faqQuestion2')"></div>
					<div class="item_znamenko"></div>
					<div class="item_inside">
						{{ $t('faqAnswer2') }}
					</div>
				</div>
				<div id="faq_3" class="faq_item" @click="toggleFAQ('faq_3')">
					<div class="item_nadpis">{{ $t('faqQuestion3') }}</div>
					<div class="item_znamenko"></div>
					<div class="item_inside">
						{{ $t('faqAnswer3') }}
					</div>
				</div>
        <div id="faq_19" class="faq_item" @click="toggleFAQ('faq_19')">
          <div class="item_nadpis">{{ $t('faqQuestion19') }}</div>
          <div class="item_znamenko"></div>
          <div class="item_inside">
            {{ $t('faqAnswer19') }}
          </div>
        </div>
				<div id="faq_4" class="faq_item" @click="toggleFAQ('faq_4')">
					<div class="item_nadpis" v-html="$t('faqQuestion4')"></div>
					<div class="item_znamenko"></div>
					<div class="item_inside" v-html="$t('faqAnswer4')">
					</div>
				</div>
				<div id="faq_5" class="faq_item" @click="toggleFAQ('faq_5')">
					<div class="item_nadpis">{{ $t('faqQuestion5') }}</div>
					<div class="item_znamenko"></div>
					<div class="item_inside">
						{{ $t('faqAnswer5') }}
					</div>
				</div>
				<div id="faq_6" class="faq_item" @click="toggleFAQ('faq_6')">
					<div class="item_nadpis">{{ $t('faqQuestion6') }}</div>
					<div class="item_znamenko"></div>
					<div class="item_inside" v-html="$t('faqAnswer6')">
					</div>
				</div>
			</div>
			<div v-if="isLoginAvailable" class="t_container faq_wrapper">
				<div id="faq_7" class="faq_item" @click="toggleFAQlogin('faq_7')">
					<div class="item_nadpis" v-html="$t('faqQuestion7')"></div>
					<div class="item_znamenko"></div>
					<div class="item_inside">
						{{ $t('faqAnswer7') }}
					</div>
				</div>
				<div id="faq_8" class="faq_item" @click="toggleFAQlogin('faq_8')">
					<div class="item_nadpis">{{ $t('faqQuestion8') }}</div>
					<div class="item_znamenko"></div>
					<div class="item_inside">
						{{ $t('faqAnswer8') }}
					</div>
				</div>
        <div id="faq_191" class="faq_item" @click="toggleFAQlogin('faq_191')">
          <div class="item_nadpis">{{ $t('faqQuestion19') }}</div>
          <div class="item_znamenko"></div>
          <div class="item_inside">
            {{ $t('faqAnswer19') }}
          </div>
        </div>
				<div id="faq_9" class="faq_item" @click="toggleFAQlogin('faq_9')">
					<div class="item_nadpis" v-html="$t('faqQuestion9')"></div>
					<div class="item_znamenko"></div>
					<div class="item_inside" v-html="$t('faqAnswer9')">
					</div>
				</div>
				<div id="faq_10" class="faq_item" @click="toggleFAQlogin('faq_10')">
					<div class="item_nadpis">{{ $t('faqQuestion10') }}</div>
					<div class="item_znamenko"></div>
					<div class="item_inside" v-html="$t('faqAnswer10')">
					</div>
				</div>
				<div id="faq_11" class="faq_item" @click="toggleFAQlogin('faq_11')">
					<div class="item_nadpis">{{ $t('faqQuestion11') }}</div>
					<div class="item_znamenko"></div>
					<div class="item_inside">
						{{ $t('faqAnswer11') }}
					</div>
				</div>
				<div id="faq_12" class="faq_item" @click="toggleFAQlogin('faq_12')">
					<div class="item_nadpis">{{ $t('faqQuestion12') }}</div>
					<div class="item_znamenko"></div>
					<div class="item_inside">
						{{ $t('faqAnswer12') }}
					</div>
				</div>
				<div id="faq_13" class="faq_item" @click="toggleFAQlogin('faq_13')">
					<div class="item_nadpis">{{ $t('faqQuestion13') }}</div>
					<div class="item_znamenko"></div>
					<div class="item_inside">
						{{ $t('faqAnswer13') }}
					</div>
				</div>
				<div id="faq_14" class="faq_item" @click="toggleFAQlogin('faq_14')">
					<div class="item_nadpis" v-html="$t('faqQuestion14')"></div>
					<div class="item_znamenko"></div>
					<div class="item_inside">
						{{ $t('faqAnswer14') }}
					</div>
				</div>
				<div id="faq_15" class="faq_item" @click="toggleFAQlogin('faq_15')">
					<div class="item_nadpis">{{ $t('faqQuestion15') }}</div>
					<div class="item_znamenko"></div>
					<div class="item_inside">
						{{ $t('faqAnswer15') }}
					</div>
				</div>
				<div id="faq_16" class="faq_item" @click="toggleFAQlogin('faq_16')">
					<div class="item_nadpis">{{ $t('faqQuestion16') }}</div>
					<div class="item_znamenko"></div>
					<div class="item_inside">
						{{ $t('faqAnswer16') }}
					</div>
				</div>
				<div id="faq_17" class="faq_item" @click="toggleFAQlogin('faq_17')">
					<div class="item_nadpis">{{ $t('faqQuestion17') }}</div>
					<div class="item_znamenko"></div>
					<div class="item_inside">
						{{ $t('faqAnswer17') }}
					</div>
				</div>
				<div id="faq_18" class="faq_item" @click="toggleFAQlogin('faq_18')">
					<div class="item_nadpis">{{ $t('faqQuestion18') }}</div>
					<div class="item_znamenko"></div>
					<div class="item_inside">
						{{ $t('faqAnswer18') }}
					</div>
				</div>
			</div>
		</div>

		<div class="footer_wrapper">
			<div class="m_container" style="display: grid; grid-template-columns: 1fr 1fr; height: 100%;">
				<div class="logo_wrapper">
					<img class="logo" src="../assets/images/figma/Telekom-Logo-840x1000.svg"/>
					<div class="logo_text_footer">{{ $t('footerTitle') }}</div>
				</div>
				<div></div>
				<div class="corporated_text">© 2022 T - Mobile Czech Republic a.s.</div>
			</div>
		</div>
	</div>
</template>

<script>
import BffAPI from "../service/BffAPI";
import LoginComponent from "../components/LoginComponent";
import ZmenaTarifComponent from "../components/ZmenaTarifComponent";
import Pet_G_overlay from "../components/cards/Pet_G_overlay";
import Pet_G_inside from "../components/cards/Pet_G_inside";
import Vice_dat_inside from "../components/cards/Vice_dat_inside";
import Vice_dat_overlay from "../components/cards/Vice_dat_overlay";
import Nadupane_telefony_inside from "../components/cards/Nadupane_telefony_inside";
import Nadupane_telefony_overlay from "../components/cards/Nadupane_telefony_overlay";
import Porad_online_inside from "../components/cards/Porad_online_inside";
import Porad_online_overlay from "../components/cards/Porad_online_overlay";
import Tv_mini_inside from "../components/cards/Tv_mini_inside";
import Tv_mini_overlay from "../components/cards/Tv_mini_overlay";
import Magenta_inside from "../components/cards/Magenta_inside";
import Magenta_overlay from "../components/cards/Magenta_overlay";
import Logout from "../components/Logout";

export default {
	name: "MigrationScreen",
	components: {
    Logout,
		LoginComponent,
		ZmenaTarifComponent,
		Pet_G_overlay,
		Pet_G_inside,
		Vice_dat_inside,
		Vice_dat_overlay,
		Nadupane_telefony_inside,
		Nadupane_telefony_overlay,
		Porad_online_inside,
		Porad_online_overlay,
		Tv_mini_inside,
		Tv_mini_overlay,
		Magenta_inside,
		Magenta_overlay
	},
	data: function () {
		return {
			jazyk_verze: "cs",
			pet_g_show: "Pet_G_overlay",
			vice_dat_show: "Vice_dat_overlay",
			nadupane_telefony_show: "Nadupane_telefony_overlay",
			porad_online_show: "Porad_online_overlay",
			tv_mini_show: "Tv_mini_overlay",
			magenta_show: "Magenta_overlay"
		}
	},
	methods: {
		scrollToId(id) {
			document.getElementById(id).scrollIntoView()
		},
		toggle_card(component) {
			if (component == "Pet_G") {
				if (this.pet_g_show.includes("overlay")) {
					this.sendCardEvent('Pet_G', 'tile_click')
					this.pet_g_show = "Pet_G_inside"
				} else {
					this.pet_g_show = "Pet_G_overlay"
				}
			} else if (component == "Vice_dat") {
				if (this.vice_dat_show.includes("overlay")) {
					this.sendCardEvent('Vice_dat', 'tile_click')
					this.vice_dat_show = "Vice_dat_inside"
				} else {
					this.vice_dat_show = "Vice_dat_overlay"
				}
			} else if (component == "Nadupane_telefony") {
				if (this.nadupane_telefony_show.includes("overlay")) {
					this.sendCardEvent('Nadupane_telefony', 'tile_click')
					this.nadupane_telefony_show = "Nadupane_telefony_inside"
				} else {
					this.nadupane_telefony_show = "Nadupane_telefony_overlay"
				}
			} else if (component == "Porad_online") {
				if (this.porad_online_show.includes("overlay")) {
					this.sendCardEvent('Porad_online', 'tile_click')
					this.porad_online_show = "Porad_online_inside"
				} else {
					this.porad_online_show = "Porad_online_overlay"
				}
			} else if (component == "Tv_mini") {
				if (this.tv_mini_show.includes("overlay")) {
					this.sendCardEvent('Tv_mini', 'tile_click')
					this.tv_mini_show = "Tv_mini_inside"
				} else {
					this.tv_mini_show = "Tv_mini_overlay"
				}
			} else if (component == "Magenta") {
				if (this.magenta_show.includes("overlay")) {
					this.sendCardEvent('Magenta', 'tile_click')
					this.magenta_show = "Magenta_inside"
				} else {
					this.magenta_show = "Magenta_overlay"
				}
			}
		},
		sendCardEvent(id, event) {
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push({
				'event': event,
				'tile_type': id
			});
		},
		sendCardFaqEvent(id, event) {
			window.dataLayer = window.dataLayer || [];
			let numFaq = id.replace( /^\D+/g, '')

			let myHTML = this.$t('faqQuestion'+(numFaq === '1' ? '' : numFaq), 'en')
			let strippedHtml = myHTML.replace(/<[^>]+>/g, '');

			window.dataLayer.push({
				'event': event,
				'tile_type': id,
				'tile_text': strippedHtml
			});
		},
		changeLang() {

			if (this.jazyk_verze !== 'en') {
				this.$i18n.locale = 'en'
				this.jazyk_verze = "en"
			} else {
				this.$i18n.locale = 'cs'
				this.jazyk_verze = "cs"
			}

			// reload title
			window.document.title = this.$t('pageTitle')

			BffAPI.setLanguage(this.jazyk_verze)
			if (this.$store.state.jwt !== '') {
				// reload data
				this.$refs.tariffComponent.tryAgain();
			}
		},
		redirectToTmo() {
			window.location.href = "https://www.t-mobile.cz"
		},
		lngBottomToggle() {
			const select_el = document.getElementById("lng_select")
			if (select_el.classList.contains("hide")) {
				select_el.classList.remove("hide")
			} else {
				select_el.classList.add("hide")
			}
		},
		toggleFAQ(id) {

			const faqID = document.getElementById(id)
			const faq_1 = document.getElementById("faq_1")
			const faq_2 = document.getElementById("faq_2")
			const faq_3 = document.getElementById("faq_3")
			const faq_4 = document.getElementById("faq_4")
			const faq_5 = document.getElementById("faq_5")
			const faq_6 = document.getElementById("faq_6")
      const faq_19 = document.getElementById("faq_19")

			if (faqID.classList.contains("active")) {
				faqID.classList.remove("active")
			} else {
				if (faq_1.classList.contains("active")) {
					faq_1.classList.remove("active")
				}
				if (faq_2.classList.contains("active")) {
					faq_2.classList.remove("active")
				}
				if (faq_3.classList.contains("active")) {
					faq_3.classList.remove("active")
				}
				if (faq_4.classList.contains("active")) {
					faq_4.classList.remove("active")
				}
				if (faq_5.classList.contains("active")) {
					faq_5.classList.remove("active")
				}
				if (faq_6.classList.contains("active")) {
					faq_6.classList.remove("active")
				}
        if (faq_19.classList.contains("active")) {
          faq_19.classList.remove("active")
        }
				faqID.classList.add("active")
				this.sendCardFaqEvent(id, "drop_down_clicks")
			}
		},
		toggleFAQlogin(id) {

			const faqID = document.getElementById(id)
			const faq_7 = document.getElementById("faq_7")
			const faq_8 = document.getElementById("faq_8")
			const faq_9 = document.getElementById("faq_9")
			const faq_10 = document.getElementById("faq_10")
			const faq_11 = document.getElementById("faq_11")
			const faq_12 = document.getElementById("faq_12")
			const faq_13 = document.getElementById("faq_13")
			const faq_14 = document.getElementById("faq_14")
			const faq_15 = document.getElementById("faq_15")
			const faq_16 = document.getElementById("faq_16")
			const faq_17 = document.getElementById("faq_17")
			const faq_18 = document.getElementById("faq_18")
      const faq_191 = document.getElementById("faq_191")

			if (faqID.classList.contains("active")) {
				faqID.classList.remove("active")
			} else {
				if (faq_7.classList.contains("active")) {
					faq_7.classList.remove("active")
				}
				if (faq_8.classList.contains("active")) {
					faq_8.classList.remove("active")
				}
				if (faq_9.classList.contains("active")) {
					faq_9.classList.remove("active")
				}
				if (faq_10.classList.contains("active")) {
					faq_10.classList.remove("active")
				}
				if (faq_11.classList.contains("active")) {
					faq_11.classList.remove("active")
				}
				if (faq_12.classList.contains("active")) {
					faq_12.classList.remove("active")
				}
				if (faq_13.classList.contains("active")) {
					faq_13.classList.remove("active")
				}
				if (faq_14.classList.contains("active")) {
					faq_14.classList.remove("active")
				}
				if (faq_15.classList.contains("active")) {
					faq_15.classList.remove("active")
				}
				if (faq_16.classList.contains("active")) {
					faq_16.classList.remove("active")
				}
				if (faq_17.classList.contains("active")) {
					faq_17.classList.remove("active")
				}
				if (faq_18.classList.contains("active")) {
					faq_18.classList.remove("active")
				}
        if (faq_191.classList.contains("active")) {
          faq_191.classList.remove("active")
        }
				faqID.classList.add("active")
				this.sendCardFaqEvent(id, "drop_down_clicks")
			}

		}
	},
	computed: {
		isLoginAvailable() {
			return (this.$store.state.jwt != undefined) && (this.$store.state.jwt.length > 1)
		},
		jazyk_aktivni() {
			return this.jazyk_verze
		},
		isMigrationDataLoaded() {
			return this.$store.state.isMigrationDataLoaded
		},
		dataError() {
			return this.$store.state.isBasicInfoDataError
		},
		isRelevantUseCase() {
			if (this.$store.state.isMigrationDataLoaded) {
				if (this.$store.state.basicInfoData.eligibilityCheckError !== null
						&& (this.$store.state.basicInfoData.eligibilityCheckError.code === 'NOT_ALLOWED_FOR_PREPAID'
								|| this.$store.state.basicInfoData.eligibilityCheckError.code === 'NO_MOBILE_VOICE_SERVICE_EXISTS'
								|| this.$store.state.basicInfoData.eligibilityCheckError.code === 'NOT_ALLOWED_FOR_B2B')) {
					return false
				}
			}
			return true
		}
	}
}
</script>

<style scoped>
.card_chevron {
  color: #007FAF;
  transform: scale(1) translateY(1px);
}
.action_wrapper_logout {
  width: fit-content;
  margin: 0 auto;
  margin-bottom: 40px;
  margin-top: 10px;
}
.login_cards_wrapper {
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	margin-bottom: 70px !important;
}

.login_card_wrapper {
	background: #FFFFFF;
	box-shadow: 0px 6px 20px rgba(0, 0, 0, 0.1);
	border-radius: 8px;
	padding: 34px 26px 0px 26px;
	width: 343px;
	height: auto;
  padding-bottom: 30px;
}

.login_card_nadpis {
	font-family: "TeleNeoLocalExtraBold";
	-webkit-font-smoothing: antialiased !important;
	text-rendering: optimizeLegibility !important;
	font-weight: 800;
	font-size: 36px;
	line-height: 41px;
	letter-spacing: -0.3px;
	padding-top: 21px;
	padding-bottom: 10px;
}

.login_card_text {
	font-family: "TeleNeoLocalRegular";
	-webkit-font-smoothing: antialiased !important;
	text-rendering: optimizeLegibility !important;
	font-weight: 400;
	font-size: 21px;
	line-height: 24px;
	letter-spacing: -0.3px;
	color: #262626;
}

.login_first_card {
	color: #e20074;
	place-self: center left;
}

.login_second_card {
	color: #EC7F6B;
	place-self: center;
}

.login_last_card {
	color: #FF9A1E;
	place-self: center right;
}

.galerie_wrapper {
	width: 100%;
	display: grid;
	grid-template-columns: 343px auto 343px;
	grid-template-rows: 295px 295px 295px 295px;
	grid-template-areas:
    "pet_g vice_dat vice_dat"
    "pet_g vice_dat vice_dat"
    "nadupane_telefony porad_online porad_online"
    "tv_mini tv_mini magenta_one";
	row-gap: 64px;
	column-gap: 64px;
}

.pet_g_item {
	grid-area: pet_g;
}

.magenta_item {
	grid-area: magenta_one;
}

.tv_mini_item {
	grid-area: tv_mini;
}

.vice_dat_item {
	grid-area: vice_dat;
}

.nadupane_telefony_item {
	grid-area: nadupane_telefony;
}

.porad_online_item {
	grid-area: porad_online;
}

.galerie_item {
	width: 100%;
	height: 100%;
}

.nadpis_main_sekce {
	font-family: "TeleNeoLocalExtraBold";
	-webkit-font-smoothing: antialiased !important;
	text-rendering: optimizeLegibility !important;
	font-weight: 800;
	font-size: 48px;
	line-height: 55px;
	letter-spacing: -0.3px;
	color: #262626;
	padding: 0px 0px 16px 0px !important;
}

.logo_text_footer {
	padding-left: 16px;
	width: fit-content;
	height: fit-content;
	place-self: center left;
	font-family: "TeleNeoLocalExtraBold";
	-webkit-font-smoothing: antialiased !important;
	text-rendering: optimizeLegibility !important;
	font-weight: 800;
	font-size: 14px;
	line-height: 16px;
	letter-spacing: -0.3px;
	color: #FFFFFF;
}

.message_icon {
	place-self: center;
}

.message_nadpis {
	font-family: "TeleNeoLocalExtraBold";
	-webkit-font-smoothing: antialiased !important;
	text-rendering: optimizeLegibility !important;
	font-weight: 800;
	font-size: 36px;
	line-height: 41px;
	letter-spacing: -0.3px;
	color: #FF9A1E;
	padding-bottom: 8px;
}

.message_text {
	font-family: "TeleNeoLocalMedium";
	-webkit-font-smoothing: antialiased !important;
	text-rendering: optimizeLegibility !important;
	font-weight: 500;
	font-size: 21px;
	line-height: 24px;
	letter-spacing: -0.3px;
	color: #262626;
	padding-bottom: 19px;
}

.message_text_special {
	display: block;
	height: fit-content;
	width: fit-content;
	place-self: center left;
	font-family: "TeleNeoLocalMedium";
	-webkit-font-smoothing: antialiased !important;
	text-rendering: optimizeLegibility !important;
	font-weight: 500;
	font-size: 28px;
	line-height: 32px;
	letter-spacing: -0.3px;
	color: #262626;
}

.message_text_part {
	display: grid;
	grid-template-columns: 1fr;
}

.message_grid {
	display: grid;
	grid-template-columns: 10% 90%;
	background: #FFF5E8;
	box-shadow: 0px 6px 20px rgba(0, 0, 0, 0.15);
	border-radius: 8px;
	padding: 24px 0px 30px 0px;
}

.jazyk_zmena_wrapper {
	position: absolute;
	top: 0px;
	right: 16px;
}

.jazyk_prepinac_wrapper {
	min-width: 128px;
	display: grid;
	grid-template-columns: 34px 1fr;
	border-radius: 8px;
	background-color: #E30074;
	padding: 14px 16px 14px 16px;
}

.jazyk_ikonka {
	max-height: 20px;
}

.jazyk_text {
	place-self: center;
	font-family: "TeleNeoLocalExtraBold";
	-webkit-font-smoothing: antialiased !important;
	text-rendering: optimizeLegibility !important;
	font-weight: 800;
	font-size: 18px;
	line-height: 20px;
	color: #FFFFFF;
}

.link-tmo:hover {
	text-decoration: underline;
	cursor: pointer;
}

.footer_wrapper {
	width: 100%;
	background: #262626;
	padding-top: 24px;
	padding-bottom: 50px;
}

.logo_wrapper {
	display: grid;
	grid-template-columns: auto auto 1fr;
}

.logo_wrapper .logo {
	place-self: center;
}

.logo_text {
	padding-left: 16px;
	place-self: center left;
}

.corporated_text {
	padding-top: 27px;
	color: white;
	font-family: "TeleNeoLocalRegular";
	-webkit-font-smoothing: antialiased !important;
	text-rendering: optimizeLegibility !important;
	font-weight: 400;
	font-size: 14px;
	line-height: 18px;
}

.social_media_wrapper {
	grid-column: 1/3;
	place-self: center right;
}

.social_media_icon {
	padding-left: 28px;
}

.language_select_wrapper {
	position: relative;
	place-self: center right;
	width: fit-content;
	display: grid;
	grid-template-columns: auto 1fr auto;
	background: #262626;
	border: 1px solid #6C6C6C;
	border-radius: 8px;
	padding: 9px 17px 9px 13px;
}

.select_lngs {
	width: calc(100% + 2px);
	transform: translateX(-1px);
	display: grid;
	grid-template-columns: 1fr;
	position: absolute;
	border: 1px solid #6C6C6C;
	border-bottom: none;
	background: #262626;
	bottom: 38px;
	left: 0;
	border-radius: 8px 8px 8px 8px;
}

.lng_select_item {
	place-self: center;
	padding: 13px 0px 13px 0px !important;
}

.lng_btn_text, .lng_select_item {
	color: white;
	font-family: "TeleNeoLocalRegular";
	-webkit-font-smoothing: antialiased !important;
	text-rendering: optimizeLegibility !important;
	font-weight: 400;
	font-size: 16px;
	line-height: 20px;
	place-self: center;
	padding: 0px 14px 0px 13px;
}

.globe_icon {
	color: white;
	place-self: center left;
}

.lng_chevron {
	color: white;
	place-self: center right;
}

.language_panel {
	background-color: #e20074;
	height: 80px;
}

.language_header {
	display: grid;
	grid-template-columns: auto 1fr;
	width: fit-content;
	color: white;
	place-self: center left;
	font-family: "TeleNeoLocalBold";
	-webkit-font-smoothing: antialiased !important;
	text-rendering: optimizeLegibility !important;
	font-weight: 700;
	font-size: 16px;
	line-height: 20px;
	color: #FFFFFF;
}

.language_header div {
	height: fit-content;
	place-self: center left;
	padding-left: 36px;
}

.language_switch_wrapper {
	display: grid;
	grid-template-columns: 1fr 1fr;
	width: fit-content;
	place-self: center right;
	height: fit-content;
}

.lng {
	place-self: center;
	display: grid;
	align-items: center;
	justify-content: center;
	background: #F90984;
	font-family: "TeleNeoLocalExtraBold";
	-webkit-font-smoothing: antialiased !important;
	text-rendering: optimizeLegibility !important;
	font-weight: 800;
	font-size: 16px;
	line-height: 20px;
	color: white;
	width: 43px;
	height: 38px;
}

.lng_cz {
	border-radius: 8px 0px 0px 8px;
}

.lng_en {
	border-radius: 0px 8px 8px 0px;
}

.language_switch_wrapper .active {
	background-color: white !important;
	color: #e20074 !important;
}

.faq_item {
	cursor: pointer;
	display: grid;
	grid-template-columns: 1fr 52px;
	padding-top: 31px;
	padding-bottom: 24px;
	border-bottom: 1px solid #DBDBDB;
}

.faq_item:last-child {
	display: grid;
	grid-template-columns: 1fr 52px;
	padding-top: 31px;
	border: none !important;
}

.faq_item .item_nadpis {
	font-family: "TeleNeoLocalMedium";
	-webkit-font-smoothing: antialiased !important;
	text-rendering: optimizeLegibility !important;
	font-weight: 500;
	font-size: 20px;
	line-height: 27px;
	color: #262626;
	text-align: left;
}

.faq_item .item_znamenko {
	place-self: center;
}

.faq_item .item_znamenko:after {
	display: block;
	transform: scale(2) translateY(-2px);
	content: "+";
}

.faq_item .item_inside {
	display: none;
	padding-top: 24px;
	font-family: "TeleNeoLocalRegular";
	-webkit-font-smoothing: antialiased !important;
	text-rendering: optimizeLegibility !important;
	font-weight: 400;
	font-size: 16px;
	line-height: 21px;
	color: #262626;
	text-align: left;
}

.faq_wrapper .active .item_znamenko:after {
	content: "-" !important;
	color: #e20074 !important;
}

.faq_wrapper .active .item_inside {
	display: block;
}

.faq_wrapper .active .item_nadpis {
	color: #e20074 !important;
}

.padding-login-ok {
	padding-top: 16px;
	padding-bottom: 0px;
}

.padding-logout-ok {
  padding-top: 16px;
  padding-bottom: 40px;
}

.vertical-align {
	display: inline-flex;
	vertical-align: middle;
}

.faq_container {
	background: #F5F5F9;
	padding-top: 64px;
	padding-bottom: 195px;
}

.faq_container .nadpis {
	font-family: "TeleNeoLocalExtraBold";
	-webkit-font-smoothing: antialiased !important;
	text-rendering: optimizeLegibility !important;
	font-weight: 800;
	font-size: 55px;
	line-height: 63px;
	text-align: center;
	letter-spacing: -0.3px;
	color: #262626;
	padding-bottom: 63px;
}

.magenta_area {
	margin: 0 auto;
	padding: 0px !important;
	width: 100%;
	background: #E20074;
	background-image: url("../assets/images/figma/new/care_ilustr.png");
	background-size: cover;
	background-repeat: no-repeat;
	background-position: center;
	box-shadow: 0px 6px 20px rgba(0, 0, 0, 0.1);
	border-radius: 8px;
}

.magenta_area .img_wrapper {
	width: 100%;
	margin: 0 auto;
}

.magenta_area img {
	width: 100%;
}

.magenta_area .nadpis {
	padding-top: 380px;
	font-family: "TeleNeoLocalExtraBold";
	-webkit-font-smoothing: antialiased !important;
	text-rendering: optimizeLegibility !important;
	font-weight: 800;
	font-size: 64px;
	line-height: 73px;
	text-align: center;
	letter-spacing: -0.3px;
	color: #FFFFFF;
}

.magenta_area .text {
	font-family: "TeleNeoLocalMedium";
	-webkit-font-smoothing: antialiased !important;
	text-rendering: optimizeLegibility !important;
	font-weight: 500;
	font-size: 24px;
	line-height: 27px;
	text-align: center;
	letter-spacing: -0.3px;
	color: #FFFFFF;
	padding-bottom: 80px;
}

.login_container {
	background: #F5F5F9;
	padding-top: 61px;
	padding-bottom: 80px;
}

.login_header {
	font-family: "TeleNeoLocalExtraBold";
	-webkit-font-smoothing: antialiased !important;
	text-rendering: optimizeLegibility !important;
	font-weight: 800;
	font-size: 48px;
	line-height: 55px;
	text-align: left;
	letter-spacing: -0.3px;
	color: #262626;
	padding-bottom: 82px;
}

.puzzle_piece {
	display: grid;
	font-family: "TeleNeoLocalExtraBold";
	-webkit-font-smoothing: antialiased !important;
	text-rendering: optimizeLegibility !important;
	background-image: url("../assets/images/figma/puzzleshape_1.png");
	background-position: center;
	background-repeat: no-repeat;
	background-size: cover;
	width: 475px;
	height: 454px;
	font-weight: 800;
	font-size: 55px;
	line-height: 63px;
	letter-spacing: -0.3px;
	color: #FFFFFF;
}

.puzzle_piece_text {
	place-self: center left;
	padding-left: 35px;
}

.header_section {
	background-image: url("../assets/images/figma/hero_web.png");
	background-position: center;
	background-repeat: no-repeat;
	background-size: auto 100%;
	padding: 22px 0px;
}

.main_text {
	padding-top: 64px !important;
}

.sekce_wrapper {
	margin-top: 55px !important;
	margin-bottom: 80px !important;
}

.dlazdice_wrapper {
	max-width: 1350px !important;
	display: flex;
	justify-content: space-between;
	flex-wrap: wrap;
	margin-top: 47px !important;
}

.dlazdice {
	display: grid;
	grid-template-columns: 1fr;
	width: 343px;
	height: 295px;
	background: #FFFFFF;
	box-shadow: 0px 6px 20px rgba(0, 0, 0, 0.1);
	border-radius: 8px;
	margin: 35px auto;
	padding: 31px 16px 26px 16px;
}

.dlazdice img {
	place-self: center;
}

.c_text {
	font-family: "TeleNeoLocalRegular";
	-webkit-font-smoothing: antialiased !important;
	text-rendering: optimizeLegibility !important;
	font-weight: 400;
	font-size: 24px;
	line-height: 27px;
	text-align: center;
	letter-spacing: -0.3px;
	color: #262626;
}

.sekce_header {
	font-family: "TeleNeoLocalExtraBold";
	-webkit-font-smoothing: antialiased !important;
	text-rendering: optimizeLegibility !important;
	font-weight: 800;
	font-size: 55px;
	line-height: 63px;
	text-align: center;
	letter-spacing: -0.3px;
	color: #262626;
	padding-bottom: 19px;
}

.dlazdice_text {
	font-family: "TeleNeoLocalExtraBold";
	-webkit-font-smoothing: antialiased !important;
	text-rendering: optimizeLegibility !important;
	font-weight: 800;
	font-size: 36px;
	line-height: 41px;
	text-align: center;
	letter-spacing: -0.3px;
	color: #262626;
	text-align: center;
}

.t_container {
	max-width: 888px;
	margin: 0 auto;
	text-align: center;
	padding-left: 15px;
	padding-right: 15px;
}

.m_container {
	position: relative;
	max-width: 1270px;
	margin: 0 auto;
	padding-left: 15px;
	padding-right: 15px;
}

.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
	opacity: 0;
}

.container, .container-lg, .container-md, .container-sm, .container-xl {
	max-width: 2000px !important;
}

@supports (-webkit-touch-callout: none) {
	/* CSS specific to iOS devices */
	.sekce_header, .puzzle_piece, .dlazdice_text, .c_text, .login_header {
		letter-spacing: -0.05rem !important;
	}

	.magenta_area .text {
		letter-spacing: -0.05rem !important;
	}

	.magenta_area .nadpis {
		letter-spacing: -0.05rem !important;
	}

	.faq_container .nadpis {
		letter-spacing: -0.05rem !important;
	}

	.faq_item .item_inside {
		letter-spacing: -0.05rem !important;
	}

	.faq_item .item_nadpis {
		letter-spacing: -0.05rem !important;
	}
}

@media only screen and (max-width: 1050px) {
	.login_cards_wrapper {
		grid-template-columns: 1fr 1fr;
		row-gap: 25px;
	}

	.login_second_card, .login_first_card {
		place-self: center;
	}

	.login_last_card {
		grid-column: 1/3;
		place-self: center;
	}
}

@media only screen and (max-width: 1300px) {

	.galerie_wrapper {
		width: fit-content;
		display: grid;
		margin: 0 auto;
		grid-template-columns: 343px 343px;
		grid-template-rows: 295px 295px 654px 295px 295px;
		grid-template-areas:
    "pet_g nadupane_telefony"
    "pet_g magenta_one"
    "vice_dat vice_dat"
    "porad_online porad_online"
    "tv_mini tv_mini";
		row-gap: 25px;
		column-gap: 25px;
	}
}

@media only screen and (max-width: 770px) {

	.jazyk_ikonka {
		display: none;
	}

	.jazyk_prepinac_wrapper {
		text-align: center;
		display: block;
	}

	.message_text_special {
		display: block;
		height: fit-content;
		width: fit-content;
		place-self: center left;
		font-family: "TeleNeoLocalMedium";
		-webkit-font-smoothing: antialiased !important;
		text-rendering: optimizeLegibility !important;
		font-weight: 500;
		font-size: 16px;
		line-height: 18px;
		letter-spacing: -0.3px;
		color: #262626;
	}

	.puzzle_piece_text {
		place-self: center center;
		padding-left: 0px;
	}

	.nadpis_main_sekce {
		font-size: 32px !important;
		line-height: 36px !important;
	}

	.login_cards_wrapper {
		grid-template-columns: 1fr !important;
		row-gap: 25px;
	}

	.login_second_card, .login_first_card {
		grid-column: 1;
		place-self: center;
	}

	.login_last_card {
		grid-column: 1;
		place-self: center;
	}

	.galerie_wrapper {
		width: 100%;
		display: grid;
		grid-template-columns: auto;
		grid-template-rows: 390px 500px 418px 276px 276px 276px;
		grid-template-areas:
    "pet_g"
    "vice_dat"
    "porad_online"
    "tv_mini"
    "nadupane_telefony"
    "magenta_one";
		row-gap: 25px;
		column-gap: 0px;
		padding-bottom: 35px !important;
	}

	.message_grid {
		margin: 30px 16px 37px 16px !important;
		grid-template-columns: 1fr;
	}

	.first_message {
		margin-top: 175px !important;
	}

	.message_nadpis, .message_text, .message_text_special {
		text-align: center;
	}

	.message_text_part .btn_magenta {

		place-self: center;
	}

	.footer_wrapper {

	}

	.logo_wrapper, .corporated_text {
		place-self: center;
		grid-column: 1/3;
	}

	.language_panel {
		display: none !important;
	}

	.header_section {
		background-image: url("../assets/images/figma/hero_mobile.png");
		background-position: center;
		background-repeat: no-repeat;
		background-size: auto 100%;
		padding: 22px 0px;
		margin-bottom: 144px;
	}

	.header_section .m_container {
		padding: 0 !important;
		padding-top: 437px !important;
	}

	.puzzle_piece {
		display: grid;
		font-family: "TeleNeoLocalExtraBold";
		-webkit-font-smoothing: antialiased !important;
		background: #e20074 !important;
		width: 100%;
		height: 204px;
		font-weight: 800;
		font-size: 42px;
		line-height: 48px;
		text-align: center;
		letter-spacing: -0.3px;
		color: #FFFFFF;
		padding: 0px !important;
		border-radius: 0px 20px 20px 0px;
		margin-bottom: -164px;
	}

	.puzzle_piece_text {
		text-align: center;
	}

	.main_text {
		padding-top: 35px !important;
	}

	.dlazdice_wrapper {
		margin-top: 36px !important;
	}

	.dlazdice {
		margin-bottom: 0px !important;
		width: 343px;
		height: 220px !important;
		pading-top: 26px !important;
	}

	.dlazdice_text {
		font-size: 28px !important;
		line-height: 32px !important;
	}

	.dlazdice img {
		max-width: 80px !important;
	}

	.sekce_header {
		font-family: "TeleNeoLocalExtraBold";
		-webkit-font-smoothing: antialiased !important;
		text-rendering: optimizeLegibility !important;
		font-weight: 800;
		font-size: 42px;
		line-height: 48px;
		text-align: center;
		letter-spacing: -0.3px;
		color: #262626;
		padding-bottom: 15px !important;
	}

	.login_header {
		font-size: 42px !important;
		line-height: 48px !important;
	}

	.magenta_area {
		margin: 0 auto;
		padding: 0px !important;
		width: 100%;
		background: #E20074;
		background-image: url("../assets/images/figma/new/magenta_area_background_better.png");
		background-size: 160%;
		background-repeat: no-repeat;
		background-position: center top;
		box-shadow: 0px 6px 20px rgba(0, 0, 0, 0.1);
		border-radius: 8px;
	}

	.magenta_area .text {
		padding-top: 357px !important;
	}

	.m_container {
		padding-left: 16px !important;
		padding-right: 16px !important;
	}

  .action_wrapper_logout span {
    font-family: "TeleNeoLocalRegular";
    -webkit-font-smoothing: antialiased !important;
    text-rendering: optimizeLegibility !important;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    color: #72003B;
  }
}
</style>
